import "./SelectedBericht.scss";

const SelectedBericht = ({bericht, baseBerichten, setBaseBerichten, setSelectedMessageOpen}) => {

    return(
        <div className="selectedbericht">
            <div onClick={()=>setSelectedMessageOpen(false)} className="selectedbericht__left"></div>
            <div className="selectedbericht__right">
                <header className="selectedbericht__right__header">
                    <nav className="selectedbericht__right__header__nav">
                    <div>
                        <button className="selectedbericht__right__header__nav__btn">
                            <i class="fa-regular fa-comment selectedbericht__right__header__nav__btn--icon"></i>
                        </button>
                        <button onClick={()=>setBaseBerichten(baseBerichten.map(_bericht => _bericht.id === bericht.id ? {..._bericht, read: !bericht.read} : _bericht))} className="selectedbericht__right__header__nav__btn">
                            {!bericht.read && <i class="fa-regular fa-eye-slash selectedbericht__right__header__nav__btn--icon"></i>}
                            {bericht.read && <i class="fa-regular fa-eye selectedbericht__right__header__nav__btn--icon"></i>}
                        </button>
                        <button onClick={()=>setBaseBerichten(baseBerichten.map(_bericht => _bericht.id === bericht.id ? {..._bericht, archived: !bericht.archived} : _bericht))} className="selectedbericht__right__header__nav__btn">
                            {!bericht.archived && <i class="fa-regular fa-folder selectedbericht__right__header__nav__btn--icon"></i>}
                            {bericht.archived && <i class="fa-solid fa-folder selectedbericht__right__header__nav__btn--icon"></i>}
                        </button>
                    </div>
                    <i onClick={()=>setSelectedMessageOpen(false)} class="fa-solid fa-xmark selectedbericht__right__header__nav__close"></i>
                    </nav>
                    <h1 className="selectedbericht__right__header__title">{bericht.message}</h1>
                </header>
                <div className="selectedbericht__right__content">
                    {!bericht.message && <p className="selectedbericht__right__content__nodetails">Geen details gevonden voor dit bericht</p>}
                    {bericht.message && <p className="selectedbericht__right__content__details">{bericht.message}</p>}
                </div>
            </div>
        </div>
    );
        
    
}

export default SelectedBericht;